export default "__VITE_ASSET__CFBNHqaf__"